var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "channel-overall-chart" },
    [
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.chartView") },
                      expression: "{ content: $t('report.chartView') }",
                    },
                  ],
                  attrs: {
                    classNames:
                      !_vm.tableMode && !_vm.pieChartMode ? "selected" : "",
                    onClick: function () {
                      _vm.tableMode = false
                      _vm.pieChartMode = false
                    },
                  },
                },
                [_c("md-icon", [_vm._v("insights")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.pieView") },
                      expression: "{ content: $t('report.pieView') }",
                    },
                  ],
                  attrs: {
                    classNames:
                      !_vm.tableMode && _vm.pieChartMode ? "selected" : "",
                    onClick: function () {
                      _vm.tableMode = false
                      _vm.pieChartMode = true
                    },
                  },
                },
                [_c("md-icon", [_vm._v("donut_small")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.tableView") },
                      expression: "{ content: $t('report.tableView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "selected" : "",
                    onClick: function () {
                      return (_vm.tableMode = true)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("table_view")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.download") },
                      expression: "{ content: $t('report.download') }",
                    },
                  ],
                  attrs: { onClick: _vm.exportToExcel },
                },
                [_c("md-icon", [_vm._v("download")])],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }),
      ]),
      _vm._v(" "),
      _vm.tableMode
        ? _c("TableView", {
            attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
          })
        : _c(
            "div",
            { staticClass: "chart-wrapper" },
            [
              _vm.pieChartMode
                ? _c("PieChartV2", {
                    attrs: {
                      title: _vm.title,
                      legends: _vm.legends.map(function (x) {
                        return x.legend
                      }),
                      series: _vm.getSeriesForPie(),
                      channelType: _vm.channelType,
                    },
                  })
                : _c("StackedAreaChart", {
                    attrs: {
                      title: _vm.title,
                      "x-axis-data": _vm.getXAxisData(),
                      legends: _vm.legends.map(function (x) {
                        return x.legend
                      }),
                      colors: _vm.colors,
                      series: _vm.getSeries(),
                    },
                  }),
            ],
            1
          ),
      _vm._v(" "),
      !_vm.pieChartMode
        ? _c(
            "div",
            { staticClass: "stats" },
            _vm._l(Object.keys(_vm.stats.channelChatCounts), function (key) {
              return _c("StatCard", {
                key: key,
                attrs: {
                  title: _vm.getChannelNameById(key),
                  value: _vm.stats.channelChatCounts[key],
                  unit: "chats",
                },
              })
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }